export default "__VITE_ASSET__Y4pMdpqu__"